import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { Manager, ManagerCreate, ManagerUpdate } from '../types';

export const managersAdapter: CrudAdapter<Manager, ManagerCreate, ManagerUpdate> = {
  async list({ offset, limit, sortName, sortDirection, filter }) {
    const { data, error } = await smsClient.GET('/managers/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
          archived: typeof filter?.archived === 'boolean' ? filter.archived : undefined,
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const partnerIds = payload.partner_ids ?? [];
    const { data, error } = await smsClient.POST('/managers/', {
      body: {
        name: payload.name,
        phone: payload.phone,
        email: payload.email ?? null,
        password: payload.password ?? null,
        can_change_partner: payload.can_change_partner ?? false,
        archived: payload.archived ?? false,
        partner_ids: partnerIds,
        partner_id: payload.partner_id ?? partnerIds[0] ?? null,
        user_id: payload.user_id ?? null,
      },
    });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const partnerIds = payload.partner_ids ?? [];
    const { data, error } = await smsClient.PUT('/managers/', {
      body: {
        id: payload.id,
        name: payload.name,
        phone: payload.phone,
        partner_ids: partnerIds,
        partner_id: payload.partner_id ?? partnerIds[0] ?? null,
        can_change_partner: payload.can_change_partner,
        archived: payload.archived,
        user_id: payload.user_id,
      },
    });
    if (error) throw error;
    return (data ?? payload) as Manager;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/managers/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as Manager;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/managers/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const managersStore = useCrudDataSource(managersAdapter);
